import {useQuery} from '@tanstack/react-query';
import BioMatchReportingService, {
    type ProgramDailyPoint,
    type ProgramReportingRow,
} from '../services/bioMatchReportingService';

export function useBioMatchReporting(orgId: number | undefined | null) {
    return useQuery<ProgramReportingRow[]>({
        queryKey: ['biomatch-reporting', orgId],
        queryFn: () => BioMatchReportingService.getProgramReporting(orgId as number),
        enabled: typeof orgId === 'number' && orgId > 0,
        staleTime: 60 * 1000,
    });
}

export function useBioMatchDailySeries(orgId: number | undefined | null, days = 30) {
    return useQuery<ProgramDailyPoint[]>({
        queryKey: ['biomatch-daily-series', orgId, days],
        queryFn: () => BioMatchReportingService.getProgramDailyEnrollments(orgId as number, days),
        enabled: typeof orgId === 'number' && orgId > 0,
        staleTime: 60 * 1000,
    });
}
